export const __getCodeForPreview = (maxLength: number) => (code: string): string => {
    if (code.length >= maxLength) {
        return code.substring(0, maxLength) + '...'
    }
    return code
}

const tuqqiMaxCodeAtPreview = 250
export const getCodeForPreview = __getCodeForPreview(tuqqiMaxCodeAtPreview)